import { EntityLinks, Goal, GoalType, LimitKeys } from '@griply/types';

import { hasGoalParent } from './goals/has-goal-parent';

export type GoalLimitKey =
  | LimitKeys.CreateGoal
  | LimitKeys.SubGoals
  | LimitKeys.CreateProject;

// Frozen goals are the backend's over-limit lock; counting them would block a user for good.
const isActive = ({
  completedAt,
  archivedAt,
  frozenAt,
  excludedFromLimits,
}: Goal): boolean =>
  !excludedFromLimits && !completedAt && !archivedAt && !frozenAt;

// Which of the three disjoint goal limits a goal counts against: a project wherever it is nested, else by its parents.
export const goalLimitKey = (goal: Goal, links: EntityLinks): GoalLimitKey => {
  if (goal.type === GoalType.Project) {
    return LimitKeys.CreateProject;
  }
  return hasGoalParent(goal, { links })
    ? LimitKeys.SubGoals
    : LimitKeys.CreateGoal;
};

// A migrated goal's parents live in the relationships table; without links it counts as a root goal.
export const countGoalsTowardLimit = (
  goals: Goal[],
  limitKey: GoalLimitKey,
  links: EntityLinks,
): number =>
  goals.filter(
    (goal) => isActive(goal) && goalLimitKey(goal, links) === limitKey,
  ).length;
